module.exports = __webpack_public_path__ + "img/ic_sang_na_lu.862df4c2.png";